import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import SubsidiaryInfo from './SubsidiaryInfo';
import { delayMethod } from '../../services/utils';

const SubsidiaryShow = ({ subsidiary, hideModal }) => {
  return (
    <>
      <Modal.Body>
        <SubsidiaryInfo subsidiary={subsidiary} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-info" onClick={() => delayMethod(hideModal, 180)}>
          Cerrar
        </Button>
      </Modal.Footer>
    </>
  );
};

export default SubsidiaryShow;
